import { ThemeOptions } from '@mui/material';

export const tabsThemeOptions: ThemeOptions = {
  components: {
    MuiTabs: {
      styleOverrides: {
        scrollButtons: {
          '&.Mui-disabled': { opacity: '0.2' },
        },
      },
    },
  },
};
